module.exports = __webpack_public_path__ + "static/media/27pic.2addbe2c.jpg";